import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElObject,
  genElText,
  genElDate,
  genElTextPassword,
  genElZirvuFileManager,
  genElNumber,
  genElBoolean,
} from "../../../components/utils/EditorDialogElementGenerator";
import JenisSelectorDialog from "../../../dialogs/selectors/JenisSelectorDialog";
import { Divider } from "@mui/material";

const editTitle = "Edit Opsi Pengecekan";
const addTitle = "Tambah Opsi Pengecekan";

const PengecekanMobilOptionEditorDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
  } = props;

  // dialog state
  const [showJenisSelector, setShowJenisSelector] = React.useState(false);

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;
    let newEror = {};

    const label_grup = data.label_grup
      ? data.label_grup.trim()
      : data.label_grup;
    if (label_grup === "" || label_grup === null || label_grup === undefined) {
      newEror = { ...newEror, label_grup: "Label grup harus diisi" };
      valid = false;
    }

    const keterangan = data.keterangan
      ? data.keterangan.trim()
      : data.keterangan;
    if (keterangan === "" || keterangan === null || keterangan === undefined) {
      newEror = { ...newEror, keterangan: "Keterangan harus diisi" };
      valid = false;
    }

    const kendaraan_jenis = data.data_kendaraan_jenis;
    if (!kendaraan_jenis) {
      newEror = { ...newEror, jabatan: "Jenis kendaraan harus diisi" };
      valid = false;
    }

    // const username = data.data_user.username;
    // if (username === "" || username === null || username === undefined) {
    //   newEror = { ...newEror, username: "User Name harus diisi" };
    //   valid = false;
    // }

    // const email = data.data_user.email;
    // if (email === "" || email === null || email === undefined) {
    //   newEror = { ...newEror, email: "Email harus diisi" };
    //   valid = false;
    // }

    // const password = data.data_user.password;
    // const cpassword = data.data_user.cpassword;

    // if (password || cpassword) {
    //   if (password !== cpassword) {
    //     newEror = {
    //       ...newEror,
    //       "data_user.password": "Password & Konfirmasi tidak sama",
    //       "data_user.cpassword": "Password & Konfirmasi tidak sama",
    //     };
    //     valid = false;
    //   }
    // }

    if (!valid) setError(newEror);

    return valid;
  };

  // handle UI event section

  const handleOnClickJenis = () => {
    setShowJenisSelector(true);
  };

  const handleOnConfirmJenis = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_kendaraan_jenis: selected,
        kendaraan_jenis_id: selected.id,
      });
      setShowJenisSelector(false);
    }
    return selected;
  };

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elJenis = genElObject({
    field: "data_kendaraan_jenis.nama",
    name: "Jenis",
    value: data.data_kendaraan_jenis ? data.data_kendaraan_jenis.nama : "",
    onClick: handleOnClickJenis,
  });
  const elUrutan = genElNumber({
    field: "urutan",
    name: "Urutan",
    data,
    setData,
    error,
  });
  const elLabelGrup = genElText({
    field: "label_grup",
    name: "Label Grup",
    data,
    setData,
    error,
  });
  const elKeterangan = genElText({
    field: "keterangan",
    name: "Keterangan",
    data,
    setData,
    error,
  });
  const elStatus = genElBoolean({
    field: "status",
    name: "Aktif",
    data,
    setData,
    error,
  });
  const elRequiredGambar = genElBoolean({
    field: "required_gambar",
    name: "Foto Wajib",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            onConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <JenisSelectorDialog
        title={"Pilih Jenis"}
        visible={showJenisSelector}
        onHide={() => setShowJenisSelector(false)}
        onConfirm={handleOnConfirmJenis}
      />

      <div className="col-start-center relative h-100">
        <div className={`row-start-start w-100 gap-3`}>
          <div className="col-start-start w-100 gap-3">
            <div className="row-start-start w-100 gap-3">
              {elStatus}
              {elRequiredGambar}
            </div>
            {elJenis}
            {elUrutan}
            {elLabelGrup}
            {elKeterangan}
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default PengecekanMobilOptionEditorDialog;
